// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"d517fbec","55":"0bc7feb7","171":"8c02630b","196":"45b151aa","361":"e605f5ac","453":"e7b0dab1"}[chunkId] + ".chunk.js";
};